import api from '@/api';
import { message } from "antd";
//import tableMockData from "lib/tableMockData";


const initialState = {
	pending: false,
	showSendingModal: false,
	sendingModalMessages: [],
	showApprovalModal: false,
	approvalModalRowID: null,
	loading: false,
	loadingDetails: false,
	lastOpen: null,
	documents: [],
	rowDetailData: [],
	filtered: {},
	approvalPending: false,
};


export const types = {
	SET_STATE: 'APPROVALS/SET_STATE',
};


export const reducers = (state = initialState, action) => {
	switch(action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };
		default:
			return state;
	}
}

export default reducers;



export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),



	resetApprovals: () => ({ type: types.SET_STATE, data: { ...initialState } }),



	resetApprovalModal: () => (dispatch, getState) => ({
		type: types.SET_STATE, data: {
			showApprovalModal: false,
			approvalModalRowID: null,
			approvalPending: false, initialState,
		},
	}),

	updateApproval: (rowID, data = {}) => async (dispatch, getState) => {
		const documents = getState().approvals.documents || [];

		// using findIndex() cause it stops once it finds the match
		// then we can grab the index to rebuild the array around the one changed row
		// TODO: eventually update the structure  to store documents by ID so updating one row isnt so painful and more direct
		const index = documents.findIndex(doc =>
			String(doc.WddCode) === String(rowID)
		);

		// If the row was not found do nothing
		if (index === -1) {
			return;
		}

		const newDocs = [
			...documents.slice(0, index),
			{
				...documents[index],
				...data,
			},
			...documents.slice(index + 1),
		];



		dispatch({
			type: types.SET_STATE,
			data: {
				documents: newDocs,
			},
		});
	},



	loadDocuments: (type = 'open') => async (dispatch, getState) => {
		let prevDocs    = getState().approvals.documents,
			prevDocKeys = prevDocs.reduce((accumulator, currentValue, index) => {
				accumulator[ currentValue.key ] = index;
				return accumulator;
			}, {});


		dispatch(actions.setState({ loading: true }));

		try {
			let response = await api.get(`/approvals/${type}`, { timeout: 60000 });
			//let response = await tableMockData();

			let newDocs = response.documents.map(row => {
				let key       = row.key,
					prevIndex = prevDocKeys[ key ];

				if(prevIndex !== undefined) {
					row.Status = prevDocs[ prevIndex ].Status;
					row.approval_comments = prevDocs[ prevIndex ].approval_comments;
				}

				return row;
			});


			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					documents: newDocs,
				},
			});
		} catch(err) {
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
				},
			});
		}

	},



	submitApprovals: () => async (dispatch, getState) => {
		const validDecisions = [ 'A', 'R' ];


		let toSend = getState().approvals.documents
			.filter(row => validDecisions.includes(row.Status))
			.map(row => ({
				approval_id: row.WddCode,
				decision: row.Status,
				comments: row.approval_comments,
				draft_number: row.DocNum
			}));


		if(!toSend.length) {
			message.error('Please approve or reject at least one document.');
			return false;
		}


		dispatch(actions.setState({
			pending: true,
			showSendingModal: true,
			sendingModalMessages: [],
		}));


		for(let i = 0; i < toSend.length; i++) {
			let decision = toSend[ i ], message;
			console.log('decision', decision)
			try {
				let result = await api.post('/approvals/decision', { decision: decision });
				message = result.message || `Approval Succeeded.`;
			} catch(err) {
				message = err.response.message || `An unknown error occurred.`;
			}

			dispatch(actions.setState({
				sendingModalMessages: [
					...getState().approvals.sendingModalMessages,
					message,
				],
			}));
		}


		dispatch(actions.setState({
			pending: false,
			showSendingModal: true,
		}));

		return true;
	},

	getRowDetail: (rowID) => async (dispatch, getState) => {
		// key -> rowID
		let rowDetailData = getState().approvals.rowDetailData;
		// console.log('record', record)
		console.log('rowID', rowID)
		// Already loaded
		if(rowDetailData[ rowID ] !== undefined) {
			return true;
		}


		dispatch({
			type: types.SET_STATE,
			data: {
				lastOpen: rowID,
				loadingDetails: true,
			},
		});


		try {
			let rows = await api.get(`/approvals/details/${rowID}`, { timeout: 60000 });
			//console.log(response)
			let newDetails = [ ...rowDetailData ];
			newDetails[ rowID ] = rows.details;

			dispatch({
				type: types.SET_STATE,
				data: {
					rowDetailData: newDetails,
					loadingDetails: false,
				},
			});

		} catch(err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					loadingDetails: false,
				},
			});
		}
	},


};